import { DriscollsBannerModule } from '@driscollsinc/application-banner-module-ui';
import style from './Banner.module.scss';
import { useOktaAuth, withOktaAuth } from '@okta/okta-react';

const env = window.config.API_ENV;

const Banner = () => {
    const { authState } = useOktaAuth();

    const accessToken = authState?.accessToken?.accessToken;

    return (
        authState?.isAuthenticated && (
            <DriscollsBannerModule 
                application="MD" 
                accessToken={accessToken} 
                currentLanguage="en" 
                layout="stack"
                env={env}
                className={style.mdmBanner} 
                />
        )
    );
};

export default withOktaAuth(Banner);
